import * as React from 'react'
import { Component, PropsWithChildren } from 'react'
import { ISelectPortalProps } from '@halo/components/select/interfaces'
import { createRoot } from 'react-dom/client'

const preventBubbling = (event: MouseEvent | any): void => {
    if (event) {
        event.stopPropagation()
    }
}

export class SelectPortal extends Component<PropsWithChildren<ISelectPortalProps>, {}> {
    private portal: any
    private portalElement: any
    private defaultClassNames: string[] = ['aqe-select', 'aqe-select-dropdown-container']

    // @ts-ignore
    public render() {
        return null
    }

    public componentDidMount() {
        let p: any = this.props.portalId && document.getElementById(this.props.portalId)

        if (!p) {
            p = document.createElement('div')
            p.id = this.props.portalId

            this.buildClassNames().forEach((className) => p.classList.add(className))

            this.props.container.appendChild(p)
        }

        this.portalElement = p
        this.portalElement.addEventListener('mousedown', preventBubbling)

        this.portal = createRoot(this.portalElement)

        this.componentDidUpdate()
    }

    public componentWillUnmount() {
        this.portalElement.removeEventListener('mousedown', preventBubbling)

        // Render null and let React handle the tree cleanup
        if (this.portal) {
            this.portal.render(null)
        }
        if (this.portalElement?.parentNode) {
            this.props.container.removeChild(this.portalElement)
        }
    }

    public componentDidUpdate(): void {
        if (!!this.portalElement.classList && this.portalElement.classList.length > 0) {
            this.portalElement.classList.remove(...this.portalElement.classList)
        }
        this.buildClassNames().forEach((className) => this.portalElement.classList.add(className))

        this.portal.render(<React.Fragment>{this.props.children}</React.Fragment>)
    }

    private buildClassNames(): string[] {
        const classNames = [...this.defaultClassNames]

        if (this.props.className) {
            this.props.className.split(' ').forEach((className) => classNames.push(className.trim()))
        }

        return classNames
    }
}
